/**
 * 打开表格列设置弹窗
 * @param {Object} refTable el-table 组件的 ref
 * @param {String} tableColumnRefName TableColumnSettingDialog 组件的 ref 名称
 */
export function openTableColumnSettingDialog(refTable, tableColumnRefName = 'tableColumnSettingDialog') {
  const ref = this.$refs[tableColumnRefName]
  if (!ref) {
    throw new Error('tableColumnSettingDialog ref is not found')
  }
  ref.open(refTable)
}

export const openNewWindow = (router, params) => {
  let routeData = router.resolve(params);
  window.open(routeData.href, '_blank');
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'undefined' || time === null || time === 'null') {
    return ''
  } else if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// 下载文件
export function previewUrl(url, name) {
  let suffix = url.substring(url.lastIndexOf('.') + 1, url.length)
  if (suffix === 'pdf') {
    window.open(url, name, 'width=800,height=600,top=100,left=100')
    return
  }
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.target= '_blank'
  link.setAttribute('download', parseTime(new Date()) + '-' + name + '.' + suffix)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}


export function injectLoadingProp2Array(array, propName = 'loading') {
  if (!array) {
    return
  }
  if (!Array.isArray(array)) {
    return
  }
  for (const item of array) {
    item[propName] = false
  }
}

function normalizePath(path) {
  // 将 a[0].b => a.0.b
  return path.replace(/\[(\w+)\]/g, '.$1').replace(/^\./, '')
}

function getByPath(obj, path) {
  if (!obj || !path) {
    return undefined
  }
  const parts = normalizePath(path).split('.')
  let cur = obj
  for (let i = 0; i < parts.length; i++) {
    if (cur == null) {
      return undefined
    }
    cur = cur[parts[i]]
  }
  return cur
}

export function injectLoadingProp(obj, arrayProp, propName = 'loading') {
  if (!obj || !arrayProp) {
    return
  }
  let array = getByPath(obj, arrayProp);
  if (!array) {
    return
  }
  if (!Array.isArray(array)) {
    return
  }
  injectLoadingProp2Array(array, propName)
}